"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionCardHeader = void 0;
const react_1 = __importDefault(require("react"));
const Layout_1 = require("../../../../Layout");
const ActionCard_1 = require("../../ActionCard");
const ActionCard_styles_1 = require("../../ActionCard.styles");
const ActionCardHeader = ({ iconName, contentType, badgeColour, badgeText, headingLevel = "h3", }) => {
    if ((badgeColour && !badgeText) || (!badgeColour && badgeText)) {
        throw new Error("If you have set one of badgeColour or badgeText, ensure the other is also set");
    }
    return (react_1.default.createElement(Layout_1.Flex, { flexWrap: "wrap", flexDirection: { xs: "column", md: "row" }, justifyContent: "space-between", alignItems: { xs: "start", md: "center" }, gap: "1" },
        react_1.default.createElement(ActionCard_styles_1.StyledFlex, { gap: "0.5" },
            react_1.default.createElement(ActionCard_1.ActionCard.Icon, { iconName: iconName }),
            react_1.default.createElement(ActionCard_1.ActionCard.ContentType, { contentType: contentType, headingLevel: headingLevel })),
        badgeColour && badgeText && (react_1.default.createElement(ActionCard_1.ActionCard.Badge, { badgeColour: badgeColour, badgeText: badgeText }))));
};
exports.ActionCardHeader = ActionCardHeader;
exports.ActionCardHeader.displayName = "ActionCardHeader";
//# sourceMappingURL=ActionCardHeader.js.map